import SupportPage from "@/features/support/page";

export default function Page() {
  return <SupportPage />;
}
